/** localStorage because the main flow's payment page already reads `planTier`. */
const PLAN_TIER_STORAGE_KEY = 'planTier'
const PLAN_PRICE_STORAGE_KEY = 'planPriceId'

type PlanSelection = {
  tier: string
  priceId: string
}

export const writePlanSelection = ({ tier, priceId }: PlanSelection): void => {
  localStorage.setItem(PLAN_TIER_STORAGE_KEY, tier)
  localStorage.setItem(PLAN_PRICE_STORAGE_KEY, priceId)
}
